<div class="container-fluid" appPadding>
  <div class="row">
    <div class="col-12 col-md-6">
      <h6>{{ utils.getAppName() }} New Zealand Ltd</h6>

      <p style="white-space: pre-line;">
        {{ utils.getCompanyAddress() }}
      </p>

      <h6>Sales &amp; Support</h6>
      <p>
        <ng-container *ngIf="utils.getSalesPhone()">
          Tel {{ utils.getSalesPhone() }}<br />
        </ng-container>

        <ng-container *ngIf="utils.getSalesEmailAddress()">
          <a [href]="'mailto:' + utils.getSalesEmailAddress()">{{ utils.getSalesEmailAddress() }}</a> <br />
        </ng-container>

        <a [href]="'mailto:' + utils.getSupportEmailAddress()">{{ utils.getSupportEmailAddress() }}</a>
      </p>

      <iframe
        *ngIf="utils.showMap()"
        style="border: 0;"
        [src]="utils.getMapIframeUrl()"
        width="100%"
        height="350"
        frameborder="0"
        allowfullscreen="allowfullscreen">
      </iframe>
    </div>
  </div>
</div>
